import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query ProjectCommonData($projectId: Int!) {
    project(id: $projectId) {
      id

      # "last used asset type" detection
      generationRequests(first: 1) {
        edges {
          node {
            ... on RecomposeRequest {
              recomposeMode
              assetType
              generationTool
              chainGenerationTool
              chainId
              language
              languageTargetFormality
              briefTitle
              briefBody
              emailPromotion
              sourceType
              generationGuidance {
                campaignKeywords
              }
            }
            ... on SuggestionRequest {
              suggestionMode
              assetType
              generationTool
              chainGenerationTool
              customMultiPromptId
              chainId
              language
              languageTargetFormality
              briefTitle
              briefBody
              emailPromotion
              freestyleToolId
              freestyleToolAllInstructions
              freestyleToolAllInstructionsData
              subTemplate {
                id
              }
              generationGuidance {
                campaignKeywords
              }
            }
          }
        }
      }
    }
  }
`;

export const queryProjectCommonData = async ({ projectId }, options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp(result.data);
};
